export function cookiesEnabled() {
  return navigator.cookieEnabled;
}

export function getMaybeAutocompletedDateOfBirth(args: {
  month?: string;
  day?: string;
  year?: string;
}): Date | undefined {
  const { month, day, year } = args;
  if (month && day && year) {
    const autoCompleteDate = new Date(+year, +month, +day);
    if (!isNaN(autoCompleteDate.getTime())) {
      return autoCompleteDate;
    }
  }
}
